// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function StrategyIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M8.497 18.503a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm0 7a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM4.289 12.796l1.794-1.793-1.794-1.792a1 1 0 1 1 1.415-1.415l1.793 1.793 1.792-1.793a1 1 0 0 1 1.415 1.415L8.91 11.003l1.794 1.793A1 1 0 0 1 9.29 14.21l-1.792-1.794-1.793 1.794a1 1 0 1 1-1.415-1.415Zm23.415 12a.999.999 0 0 1-.325 1.631 1 1 0 0 1-1.09-.216l-1.792-1.794-1.793 1.794a1 1 0 1 1-1.415-1.415l1.794-1.793-1.794-1.792a1 1 0 1 1 1.415-1.415l1.793 1.793 1.792-1.793a1 1 0 0 1 1.415 1.415l-1.794 1.792 1.794 1.793Zm-5.649-11.19c-.772 2.792-3.165 5.205-5.816 5.867a1 1 0 1 1-.491-1.94c1.954-.489 3.794-2.364 4.375-4.46.399-1.437.402-3.625-1.839-5.862l-.287-.294v2.586a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H19.41l.294.293c2.28 2.28 3.115 5.055 2.351 7.81Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
